/**
 * Solo developer support address. Receives any-amount donations across
 * EVM chains. Same address works on Polygon, Base, Ethereum, Arbitrum,
 * Optimism, BSC — anywhere on the EVM standard. Sender picks the chain;
 * Polygon/Base recommended for sub-cent gas on small donations.
 *
 * Coverage purpose: AI tooling subscription (~$200/mo) + general
 * coffee-grade appreciation. No tier, no expectation — anything helps.
 *
 * Sourced from user direct disclosure 2026-05-20.
 */
export const SUPPORT_EVM_ADDRESS = '0xaf294b6a2a870d80bc7004c1f9414091ba242e47'
